module.exports = __webpack_public_path__ + "static/img/turbofuel_256.b5e97aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/turbofuel_256.png
// module id = kQuH
// module chunks = 0